import React from "react";
import Service from "../Items/Service";

const servicesData = [
  // === DATA ANALYST SKILLS ===
  {
    id: 1,
    name: "Data Analysis",
    content:
      "Analyze and interpret data using Python libraries like Pandas and NumPy to gain actionable insights.",
    icon: "icon-graph",
  },
  {
    id: 2,
    name: "Data Visualization",
    content:
      "Create clear and compelling data visualizations using Matplotlib, Seaborn, Power BI, or Tableau.",
    icon: "icon-graph",
  },
  {
    id: 3,
    name: "Machine Learning",
    content:
      "Develop basic machine learning models for prediction and classification using Scikit-learn or TensorFlow.",
    icon: "icon-layers",
  },

  // === WEB DEVELOPER SKILLS ===
  {
    id: 4,
    name: "Frontend Development",
    content:
      "Build responsive user interfaces with HTML, CSS, JavaScript, and React.js.",
    icon: "icon-screen-desktop",
  },
  {
    id: 5,
    name: "Backend Development",
    content:
      "Create and manage RESTful APIs and databases using Node.js or Laravel.",
    icon: "icon-drawer",
  },
  {
    id: 6,
    name: "SEO & Optimization",
    content:
      "Optimize website performance by enhancing loading speed, minimizing code, and leveraging caching strategies.",
    icon: "icon-magnifier",
  },
];

function Services() {
  return (
    <div className="row -mt-20">
      {servicesData.map((service) => (
        <div className="col-md-4 col-sm-6 mt-20" key={service.id}>
          <Service service={service} />
        </div>
      ))}
    </div>
  );
}

export default Services;
